import { render, staticRenderFns } from "./showStaffList.vue?vue&type=template&id=0be40fa4&scoped=true"
import script from "./showStaffList.vue?vue&type=script&lang=js"
export * from "./showStaffList.vue?vue&type=script&lang=js"
import style0 from "./showStaffList.vue?vue&type=style&index=0&id=0be40fa4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be40fa4",
  null
  
)

export default component.exports